__turbopack_context__.v({
  "bounce-in-1": "IceChatButton-module-scss-module__bgJehq__bounce-in-1",
  "bounce-in-2": "IceChatButton-module-scss-module__bgJehq__bounce-in-2",
  "bounce-in-3": "IceChatButton-module-scss-module__bgJehq__bounce-in-3",
  "bumpUp": "IceChatButton-module-scss-module__bgJehq__bumpUp",
  "button": "IceChatButton-module-scss-module__bgJehq__button",
  "container": "IceChatButton-module-scss-module__bgJehq__container",
  "default": "IceChatButton-module-scss-module__bgJehq__default",
  "icon": "IceChatButton-module-scss-module__bgJehq__icon",
  "iconHover": "IceChatButton-module-scss-module__bgJehq__iconHover",
  "iconHover1": "IceChatButton-module-scss-module__bgJehq__iconHover1",
  "iconHover2": "IceChatButton-module-scss-module__bgJehq__iconHover2",
  "iconHover3": "IceChatButton-module-scss-module__bgJehq__iconHover3",
  "inside": "IceChatButton-module-scss-module__bgJehq__inside",
  "outside": "IceChatButton-module-scss-module__bgJehq__outside",
});
